<template>
    <div id="UserPlacesListM">
        <b-container>
            <b-modal id="modPlacesList" no-close-on-backdrop no-close-on-esc>
                <template v-slot:modal-header>
                    {{ $t("CHOOSE_PLACE")}}
                    <b-button size="sm" @click="close()">
                        x
                    </b-button>
                </template>
                <b-table
                        ref="itemList"
                        selectable
                        :items="items"
                        :fields="fields"
                        striped
                        head-row-variant="info"
                        @row-selected="onRowSelected"
                >
                </b-table>
                <template v-slot:modal-footer>
                    <b-button @click="close">
                        {{ $t("CLOSE")}}
                    </b-button>
                </template>
            </b-modal>
        </b-container>
    </div>
</template>

<script>
import { BContainer, BModal, BTable, BButton } from 'bootstrap-vue';

export default {
  name: 'UserPlacesListM',
  components: {
      BContainer, BModal, BTable, BButton
  },
  props: {
    userName: String,
    tripName: String,
    published: Boolean,
    blocked: Boolean,
    free: Boolean
  },
  data: function() {
    return {
      title: '',
      fields: [
          {
              key: 'placeName',
              label: '',
              sortable: true
          },
          {
              key: 'pubDate',
              label: this.$t('DATE'),
              sortable: true
          }
      ],
      item: {},
      items: [{}]
    }
  },
  mounted() {
      if(this.free) this.getUserPlaces();
      else this.getUserTripPlaces();
  },
  methods: {
    async getUserPlaces() {
        try {
            const response = await this.$http.get('/getUserPlaces', {
                params: {
                    userName: this.userName,
                    //published: this.published,
                    //blocked: this.blocked,
                    published: false,
                    blocked: false,
                    free: this.free
                    //free: true
                }
            });
            this.items = response.data;
            if(this.items.length == 0) {
                this.$showMsg(this.$t('EMPTY_LIST'));
                //this.$router.go(-1);
            }
            this.$bvModal.show('modPlacesList');
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async getUserTripPlaces() {
        try {
            const response = await this.$http.get('/getTripPlacesList', {
                params: {
                    userName: this.userName,
                    tripName: this.tripName,
                    //published: this.published,
                    //blocked: this.blocked,
                    published: false,
                    blocked: false,
                    free: this.free
                    //free: true
                }
            });
            this.items = response.data;
            if(this.items.length == 0) {
                this.$showMsg(this.$t('EMPTY_LIST'));
                //this.$router.go(-1);
            }
            this.$bvModal.show('modPlacesList');
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },



    onRowSelected(items) {
        this.$bvModal.hide('modPlacesList');
        let placeName = items[0].placeName;
        this.$emit('actPlace', placeName);
    },
    close() {
        this.$bvModal.hide('modPlacesList');
        this.$emit('actPlace', '');
    }
  }
}

</script>

<style>
</style>